import { useRef } from 'react';
import { type BarcodeScannerProps, useBarcodeScanner } from '@/hooks/scan-code/use-barcode-scanner';

export default function BarcodeScanner({ onScan }: BarcodeScannerProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useBarcodeScanner(videoRef, canvasRef, onScan);

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
      }}>
      <video
        ref={videoRef}
        autoPlay
        playsInline
        muted
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />
      <canvas
        ref={canvasRef}
        style={{ display: 'none' }}
      />
    </div>
  );
}
